<template>
  <div id="voice-by-sangat-list">
   

    <!-- Table Section -->
    <vs-table 
      class="vs-con-loading__container" 
      stripe 
      :sst="true" 
      maxHeight="800px"
      @search="updateSearchQuery" 
      @change-page="handleChangePage" 
      @sort="handleSort" 
      :total="FilteredCount"
      :max-items="length" 
      search 
      :data="records">
      
      <template slot="header">
        <div class="flex items-center mb-2 gap-2">
          <div class="flex flex-wrap justify-between items-center">
             <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                  <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                    <div
                      class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                      <span class="mr-2">
                        {{ page * length - (length - (FilteredCount && 1)) || 0 }}
                        -
                        {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                        of {{ total || 0 }}
                      </span>
                      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>
                      <vs-dropdown-item @click="handleChangeLength(10)">
                        <span>10</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="handleChangeLength(20)">
                        <span>20</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="handleChangeLength(50)">
                        <span>50</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="handleChangeLength(100)">
                        <span>100</span>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
          </div>
          <div class="flex flex-wrap items-center">
              <!-- Custom Pagination -->
              <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages"
                :max="totalPages / length > 7 ? 7 : 5" class="mt-1" @onchange="handleChangePage"></vs-pagination>
            </div>
 <!-- CTA Section -->
    <div class=" flex items-center justify-between">
      <div v-if="checkPermissionSlug(['video_create'])" @click="toggleAddModal"
        class="btn-add-new p-2 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary">
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Add Video</span>
      </div>
    </div>
        </div>
      </template>

      <template slot="thead">
        <vs-th>Reorder</vs-th>
        <vs-th>Sr#</vs-th>
        <vs-th sort-key="title">Title</vs-th>
        <vs-th sort-key="company_name">Company Name</vs-th>
        <vs-th>Video</vs-th>
        <vs-th sort-key="is_active">Status</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <draggable :list="localRecords" tag="tbody" handle=".drag-handle" @end="onDragEnd">
          <vs-tr :key="indextr" v-for="(tr, indextr) in localRecords">
            <vs-td class="drag-handle" title="Reorder">
              ::
            </vs-td>
            <vs-td>
              {{ page * length - (length - indextr - 1) }}
            </vs-td>

            <vs-td>
              {{ tr.title }}
            </vs-td>

            <vs-td>
              {{ tr.company_name }}
            </vs-td>

            <vs-td>
                <video height="200" width="500" :ref="'video' + indextr" :src="tr.video" controls></video>
            </vs-td>

            <vs-td>
              <vs-switch :value="tr.is_active" @click="updateStatus(tr)" />
            </vs-td>

            <vs-td>
              <div class="flex items-center">
                <feather-icon icon="EditIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="toggleEditModal(tr)" />
                <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDelete(tr._id)" />
              </div>
            </vs-td>
          </vs-tr>
        </draggable>
      </template>
    </vs-table>

    <!-- Modal for Add/Edit -->
    <action-modal 
      v-if="isModalMounted"
      :showModal.sync="isModalShow"
      :data="selectedRecord"
      :action_name="actionName"
      :module_name="module_name"
      @update-data="getData"
    />

    <!-- Video Preview Popup -->
    <vs-popup title="Video Preview" :active.sync="isVideoPreviewShow">
      <div v-if="previewVideoUrl" class="p-4">
        <video width="100%" controls :src="previewVideoUrl"></video>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import actionModal from './action.vue'
import draggable from 'vuedraggable'

export default {
  name: 'VoiceBySangatList',
  components: {
    actionModal,
    draggable
  },
  data() {
    return {
      module_name: 'Voice by sangat',
      length: 10,
      page: 1,
      search: '',
      order: [],
      
      isModalMounted: false,
      isModalShow: false,
      selectedRecord: null,
      actionName: 'Add',

      isVideoPreviewShow: false,
      previewVideoUrl: ''
    }
  },
  computed: {
    ...mapState('voiceBySangat', ['records', 'total', 'FilteredCount', 'listLoading']),
    ...mapGetters('auth', ['checkPermissionSlug']),
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    },
    localRecords: {
      get() {
        return this.records
      },
      set(val) {
        this.$store.commit('voiceBySangat/SET_STATE', { action: 'records', data: val })
      }
    }
  },
  methods: {
    ...mapActions('voiceBySangat', ['getList', 'updateStatus', 'delete', 'updateSequence']),

    getData() {
      this.getList({
        limit: this.length,
        page: this.page,
        search: this.search,
        order: this.order
      })
    },

    updateSearchQuery(val) {
      this.search = val
      this.page = 1
      this.getData()
    },

    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    handleSort(key, active) {
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.page = 1
      this.getData()
    },

    toggleAddModal() {
      this.selectedRecord = null
      this.actionName = 'Add'
      this.isModalMounted = true
      this.isModalShow = true
    },

    toggleEditModal(record) {
      this.selectedRecord = record
      this.actionName = 'Update'
      this.isModalMounted = true
      this.isModalShow = true
    },

    onDragEnd() {
      const sequences = this.localRecords.map((item, index) => {
        return {
          id: item._id,
          sequence: (this.page - 1) * this.length + index
        }
      })

      this.updateSequence({ data: sequences }).then(() => {
        this.$vs.notify({
          title: 'Success',
          text: 'Order updated successfully',
          color: 'success'
        })
      }).catch(err => {
        this.$vs.notify({
          title: 'Error',
          text: err.message,
          color: 'danger'
        })
        this.getData()
      })
    },

    updateStatus(record) {
      this.$store.dispatch('voiceBySangat/updateStatus', {
        id: record._id,
        status: !record.is_active
      }).then((res) => {
        this.$vs.notify({
          title: 'Success',
          text: res.message,
          color: 'success'
        })
        this.getData()
      })
    },

    confirmDelete(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure you want to delete this record?',
        accept: () => this.deleteRecord(id)
      })
    },

    deleteRecord(id) {
      this.$store.dispatch('voiceBySangat/delete', id).then((res) => {
        this.$vs.notify({
          title: 'Success',
          text: res.message,
          color: 'success'
        })
        this.getData()
      })
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    isModalShow(newVal) {
      if (!newVal) {
        setTimeout(() => {
          this.isModalMounted = false
        }, 300)
      }
    },
    listLoading() {
      if (this.listLoading) {
        this.$vs.loading({
          container: '#voice-by-sangat-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#voice-by-sangat-list > .con-vs-loading')
      }
    }
  }
}
</script>

<style scoped>
.drag-handle {
  cursor: grab !important;
  user-select: none;
  touch-action: none;
  font-size: 1.25rem;
  line-height: 1.75rem;
  text-align: center;
}

.drag-handle:active {
  cursor: grabbing !important;
}
</style>
